<template>
	<div class="stage-scraping-page">
		<h2>Cuadro de Mando</h2>

		<div class="sp-card sp-filters">
			<el-select v-model="filters.marca" size="small" clearable filterable placeholder="Marca" @change="fetchDashboard">
				<el-option v-for="m in marcasDisponibles" :key="m" :label="m" :value="m" />
			</el-select>
			<el-select v-model="filters.modelo" size="small" clearable filterable placeholder="Modelo" @change="fetchDashboard">
				<el-option v-for="m in modelosDisponibles" :key="m" :label="m" :value="m" />
			</el-select>
			<el-select v-model="filters.semaforo" size="small" clearable placeholder="Semáforo" @change="fetchDashboard">
				<el-option v-for="s in semaforosDisponibles" :key="s" :label="s" :value="s" />
			</el-select>
			<el-input-number v-model="filters.desviacion_min" size="small" :controls="false" placeholder="Desv. min" @change="fetchDashboard" />
			<el-input-number v-model="filters.desviacion_max" size="small" :controls="false" placeholder="Desv. max" @change="fetchDashboard" />
			<el-button size="small" type="primary" @click="fetchDashboard">Buscar</el-button>
			<el-button size="small" @click="resetFilters">Limpiar</el-button>
		</div>

		<div v-if="loading" class="sp-card stage-center" v-loading="true" element-loading-text="Cargando panel..." />
		<el-alert v-else-if="error" type="error" :closable="false" :title="error" style="margin-top: 10px;" />

		<template v-else>
			<div class="sp-top-row">
				<div class="sp-card sp-kpis-card">
					<div class="sp-title">KPIs</div>
					<div class="sp-kpis-inline">
						<div class="sp-kpi" v-for="item in kpiCards" :key="item.key">
							<div class="sp-kpi-label"><span class="sp-kpi-icon">{{ item.icon }}</span> {{ item.label }}</div>
							<div class="sp-kpi-value">{{ item.value }}</div>
						</div>
					</div>
				</div>
				<div class="sp-card sp-semaforo-card">
					<div class="sp-title">Semáforo</div>
					<div class="sp-semaforo-grid">
						<div class="sp-pill verde">Verde: {{ semaforo.verde || 0 }}</div>
						<div class="sp-pill ambar">Ámbar: {{ semaforo.ambar || 0 }}</div>
						<div class="sp-pill rojo">Rojo: {{ semaforo.rojo || 0 }}</div>
						<div class="sp-pill sin_datos">Sin datos: {{ semaforo.sin_datos || 0 }}</div>
					</div>
				</div>
			</div>

			<div class="sp-card">
				<el-tabs v-model="activeTab">
					<el-tab-pane label="Valor de flota" name="valor">
						<div class="sp-valor-total">
							<div class="sp-valor-kpi">
								<span>Valor mercado total</span>
								<strong>{{ formatCurrency(valorFlotaTotal.valor_mercado_total) }}</strong>
							</div>
							<div class="sp-valor-kpi">
								<span>Valor propio total</span>
								<strong>{{ formatCurrency(valorFlotaTotal.valor_propio_total) }}</strong>
							</div>
							<div class="sp-valor-kpi">
								<span>Vehículos con valor mercado</span>
								<strong>{{ Number(valorFlotaTotal.vehiculos_con_valor_mercado || 0) }}</strong>
							</div>
							<div class="sp-valor-kpi">
								<span>Vehículos con valor propio</span>
								<strong>{{ Number(valorFlotaTotal.vehiculos_con_valor_propio || 0) }}</strong>
							</div>
						</div>

						<div class="sp-valor-dimensiones">
							<div class="sp-valor-dimension">
								<h4>Por marca</h4>
								<el-table :data="valorPorMarca" size="mini" stripe class="sp-table-soft" :max-height="340">
									<el-table-column prop="dimension" label="Marca" min-width="130" />
									<el-table-column label="Valor mercado" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_mercado_total) }}</template>
									</el-table-column>
									<el-table-column label="Valor propio" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_propio_total) }}</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="sp-valor-dimension">
								<h4>Por familia</h4>
								<el-table :data="valorPorFamilia" size="mini" stripe class="sp-table-soft" :max-height="340">
									<el-table-column prop="dimension" label="Familia" min-width="130" />
									<el-table-column label="Valor mercado" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_mercado_total) }}</template>
									</el-table-column>
									<el-table-column label="Valor propio" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_propio_total) }}</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="sp-valor-dimension">
								<h4>Por proveedor</h4>
								<el-table :data="valorPorProveedor" size="mini" stripe class="sp-table-soft" :max-height="340">
									<el-table-column prop="dimension" label="Proveedor" min-width="130" />
									<el-table-column label="Valor mercado" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_mercado_total) }}</template>
									</el-table-column>
									<el-table-column label="Valor propio" min-width="120" align="right" header-align="right">
										<template slot-scope="{ row }">{{ formatCurrency(row.valor_propio_total) }}</template>
									</el-table-column>
								</el-table>
							</div>
						</div>
					</el-tab-pane>

					<el-tab-pane label="Vehículos" name="vehiculos">
						<el-empty v-if="vehiculos.length === 0" description="No hay vehículos para los filtros aplicados" />
						<template v-else>
							<div class="sp-vehiculo-filtros">
								<el-select v-model="vehiculoFlagFilters.falta_marca" size="mini" clearable placeholder="Falta marca">
									<el-option label="Sí" value="si" />
									<el-option label="No" value="no" />
								</el-select>
								<el-select v-model="vehiculoFlagFilters.falta_modelo" size="mini" clearable placeholder="Falta modelo">
									<el-option label="Sí" value="si" />
									<el-option label="No" value="no" />
								</el-select>
								<el-select v-model="vehiculoFlagFilters.falta_kilometraje" size="mini" clearable placeholder="Falta km">
									<el-option label="Sí" value="si" />
									<el-option label="No" value="no" />
								</el-select>
								<el-select v-model="vehiculoFlagFilters.falta_fecha_matriculacion" size="mini" clearable placeholder="Falta fecha mat.">
									<el-option label="Sí" value="si" />
									<el-option label="No" value="no" />
								</el-select>
							</div>
							<el-table :data="pageData" size="mini" style="width: 100%" stripe class="sp-table-soft">
								<el-table-column prop="MATRICULA" label="MATRICULA" min-width="120" />
								<el-table-column prop="MARCA" label="MARCA" min-width="120" />
								<el-table-column prop="MODELO" label="MODELO" min-width="120" />
								<el-table-column prop="GRUPO" label="GRUPO" min-width="110" />
								<el-table-column prop="FAMILIA" label="FAMILIA" min-width="170" />
								<el-table-column prop="PROVEEDOR" label="PROVEEDOR" min-width="130" />
								<el-table-column prop="DESVIACION_PCT" label="DESVIACIÓN" width="120" />
								<el-table-column prop="VNC" label="VNC" min-width="100" align="right" header-align="right">
									<template slot-scope="{ row }">{{ formatCurrency(row.VNC) }}</template>
								</el-table-column>
								<el-table-column prop="PRECIO_MEDIO_MERCADO" label="MEDIA MERCADO" min-width="130" align="right" header-align="right">
									<template slot-scope="{ row }">{{ formatCurrency(row.PRECIO_MEDIO_MERCADO) }}</template>
								</el-table-column>
								<el-table-column label="SEMAFORO" width="110">
									<template slot-scope="{ row }">
										<el-tag size="mini" :type="tagType(row.SEMAFORO)">{{ row.SEMAFORO || 'sin_datos' }}</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="FECHA_CONSULTA" label="FECHA CONSULTA" min-width="140">
									<template slot-scope="{ row }">{{ formatFecha(row.FECHA_CONSULTA) }}</template>
								</el-table-column>
								<el-table-column label="SIN MARCA" width="95"><template slot-scope="{ row }">{{ yesNo(row.falta_marca) }}</template></el-table-column>
								<el-table-column label="SIN MODELO" width="100"><template slot-scope="{ row }">{{ yesNo(row.falta_modelo) }}</template></el-table-column>
								<el-table-column label="SIN KMS" width="120"><template slot-scope="{ row }">{{ yesNo(row.falta_kilometraje) }}</template></el-table-column>
								<el-table-column label="SIN FECHA MAT." width="165"><template slot-scope="{ row }">{{ yesNo(row.falta_fecha_matriculacion) }}</template></el-table-column>
								<el-table-column label="Acciones" width="110" fixed="right">
									<template slot-scope="{ row }">
										<el-button size="mini" type="primary" @click="abrirFichaVehiculo(row)">Ver ficha</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div class="sp-pagination">
								<el-pagination
									background
									layout="total, sizes, prev, pager, next"
									:total="vehiculosFiltrados.length"
									:page-size="pageSize"
									:current-page.sync="currentPage"
									:page-sizes="[10, 20, 50, 100]"
									@size-change="onPageSizeChange"
								/>
							</div>
						</template>
					</el-tab-pane>

					<el-tab-pane label="Calidad de datos" name="calidad">
						<div class="sp-dimensions">
							<div v-for="dim in dimensions" :key="dim" class="sp-dimension">
								<h4>{{ dim }}</h4>
								<div class="sp-dimension-kpis">
									<div class="sp-dimension-kpi">
										<span>Total</span>
										<strong>{{ dimensionTotals(dim).total }}</strong>
									</div>
									<div class="sp-dimension-kpi">
										<span>Faltan datos</span>
										<strong>{{ dimensionTotals(dim).faltan_datos }}</strong>
									</div>
								</div>
							</div>
						</div>
						<div class="sp-charts">
							<div v-for="dim in dimensions" :key="`${dim}-chart`" class="sp-chart-card">
								<h4>{{ dim }}</h4>
								<div class="sp-chart-bars">
									<div class="sp-bar-row">
										<span>Completos</span>
										<div class="sp-bar-track">
											<div class="sp-bar-fill completos" :style="{ width: `${dimensionTotals(dim).pct_completos}%` }" />
										</div>
										<em>{{ dimensionTotals(dim).completos }}</em>
									</div>
									<div class="sp-bar-row">
										<span>Faltan</span>
										<div class="sp-bar-track">
											<div class="sp-bar-fill faltan" :style="{ width: `${dimensionTotals(dim).pct_faltan}%` }" />
										</div>
										<em>{{ dimensionTotals(dim).faltan_datos }}</em>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</template>
	</div>
</template>

<script>
import axios from 'axios'
import { getUrl } from '@/helpers/api'

export default {
	name: 'StageScrapingPanel',
	data() {
		return {
			loading: false,
			error: '',
			filters: {
				marca: '',
				modelo: '',
				semaforo: '',
				desviacion_min: null,
				desviacion_max: null
			},
			dataResponse: null,
			vehiculoFlagFilters: {
				falta_marca: '',
				falta_modelo: '',
				falta_kilometraje: '',
				falta_fecha_matriculacion: ''
			},
			currentPage: 1,
			pageSize: 10,
			activeTab: 'valor',
			dimensions: ['marca', 'familia', 'proveedor']
		}
	},
	computed: {
		kpis() { return this.dataResponse && this.dataResponse.kpi ? this.dataResponse.kpi : {} },
		valorFlota() { return this.dataResponse && this.dataResponse.valor_flota ? this.dataResponse.valor_flota : {} },
		valorFlotaTotal() { return this.valorFlota && this.valorFlota.total ? this.valorFlota.total : {} },
		valorPorMarca() { return Array.isArray(this.valorFlota.por_marca) ? this.valorFlota.por_marca : [] },
		valorPorFamilia() { return Array.isArray(this.valorFlota.por_familia) ? this.valorFlota.por_familia : [] },
		valorPorProveedor() { return Array.isArray(this.valorFlota.por_proveedor) ? this.valorFlota.por_proveedor : [] },
		kpiCards() {
			return [
				{
					key: 'total_vehiculos',
					label: 'Total vehículos',
					icon: '🚗',
					value: Number(this.kpis.total_vehiculos || 0)
				},
				{
					key: 'con_historial',
					label: 'Con historial',
					icon: '📄',
					value: Number(this.kpis.con_historial || 0)
				},
				{
					key: 'sin_historial',
					label: 'Sin historial',
					icon: '📭',
					value: Number(this.kpis.sin_historial || 0)
				},
				{
					key: 'faltan_datos_scraping',
					label: 'Faltan datos scraping',
					icon: '⚠️',
					value: Number(this.kpis.faltan_datos_scraping || 0)
				}
			]
		},
		semaforo() { return this.dataResponse && this.dataResponse.semaforo ? this.dataResponse.semaforo : {} },
		filtrosDisponibles() { return this.dataResponse && this.dataResponse.filtros_disponibles ? this.dataResponse.filtros_disponibles : {} },
		faltantesCampos() { return this.dataResponse && this.dataResponse.faltantes_campos ? this.dataResponse.faltantes_campos : {} },
		faltantesPorDimension() { return this.dataResponse && this.dataResponse.faltantes_por_dimension ? this.dataResponse.faltantes_por_dimension : {} },
		vehiculos() { return this.dataResponse && Array.isArray(this.dataResponse.vehiculos) ? this.dataResponse.vehiculos : [] },
		semaforosDisponibles() {
			return Array.isArray(this.filtrosDisponibles.semaforos) ? this.filtrosDisponibles.semaforos : ['verde', 'ambar', 'rojo', 'sin_datos']
		},
		marcasDisponibles() {
			return Array.isArray(this.filtrosDisponibles.marcas) ? this.filtrosDisponibles.marcas : []
		},
		modelosDisponibles() {
			return Array.isArray(this.filtrosDisponibles.modelos) ? this.filtrosDisponibles.modelos : []
		},
		pageData() {
			const start = (this.currentPage - 1) * this.pageSize
			return this.vehiculosFiltrados.slice(start, start + this.pageSize)
		},
		vehiculosFiltrados() {
			const checks = this.vehiculoFlagFilters
			return this.vehiculos.filter(v => {
				return this.flagMatch(v.falta_marca, checks.falta_marca) &&
					this.flagMatch(v.falta_modelo, checks.falta_modelo) &&
					this.flagMatch(v.falta_kilometraje, checks.falta_kilometraje) &&
					this.flagMatch(v.falta_fecha_matriculacion, checks.falta_fecha_matriculacion)
			})
		}
	},
	watch: {
		'vehiculos.length'() { this.currentPage = 1 },
		vehiculoFlagFilters: {
			deep: true,
			handler() {
				this.currentPage = 1
			}
		}
	},
	async created() {
		await this.fetchDashboard()
	},
	methods: {
		cleanParams(params) {
			const out = {}
			Object.keys(params || {}).forEach(key => {
				const v = params[key]
				if (v === '' || v === null || v === undefined) return
				out[key] = v
			})
			return out
		},
		async fetchDashboard() {
			this.loading = true
			this.error = ''
			try {
				const endpoints = getUrl()
				const base = endpoints && endpoints.backend ? endpoints.backend : '/'
				const url = `${base}dashboard/scrapingPanel`
				const { data } = await axios.get(url, { params: this.cleanParams(this.filters) })
				this.dataResponse = data
			} catch (error) {
				const message = error && error.response && error.response.data && error.response.data.message
					? error.response.data.message
					: `Error HTTP al cargar el panel (${(error && error.response && error.response.status) || 'sin código'})`
				this.error = message
			} finally {
				this.loading = false
			}
		},
		resetFilters() {
			this.filters = {
				marca: '',
				modelo: '',
				semaforo: '',
				desviacion_min: null,
				desviacion_max: null
			}
			this.fetchDashboard()
		},
		dimensionRows(dim) {
			const rows = this.faltantesPorDimension && this.faltantesPorDimension[dim]
			if (!Array.isArray(rows)) return []
			return rows.map((r, idx) => ({
				dimension: r.dimension || r.nombre || `${dim}_${idx + 1}`,
				total: r.total || 0,
				faltan_datos: r.faltan_datos || 0,
				falta_marca: r.falta_marca || 0,
				falta_modelo: r.falta_modelo || 0,
				falta_kilometraje: r.falta_kilometraje || 0,
				falta_fecha_matriculacion: r.falta_fecha_matriculacion || 0
			}))
		},
		dimensionTotals(dim) {
			const rows = this.dimensionRows(dim)
			const total = rows.reduce((acc, r) => acc + Number(r.total || 0), 0)
			const faltan_datos = rows.reduce((acc, r) => acc + Number(r.faltan_datos || 0), 0)
			const completos = Math.max(total - faltan_datos, 0)
			const pct_completos = total > 0 ? Math.round((completos / total) * 100) : 0
			const pct_faltan = total > 0 ? Math.round((faltan_datos / total) * 100) : 0
			return { total, faltan_datos, completos, pct_completos, pct_faltan }
		},
		flagMatch(value, filterValue) {
			if (!filterValue) return true
			const boolVal = !!value
			return filterValue === 'si' ? boolVal : !boolVal
		},
		yesNo(v) { return v ? 'SI' : 'NO' },
		tagType(semaforo) {
			const s = String(semaforo || '').toLowerCase()
			if (s === 'verde') return 'success'
			if (s === 'ambar') return 'warning'
			if (s === 'rojo') return 'danger'
			return 'info'
		},
		onPageSizeChange(size) {
			this.pageSize = size
			this.currentPage = 1
		},
		formatFecha(value) {
			if (!value) return ''
			const s = String(value).trim()
			if (!s) return ''
			if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) return s
			let iso = s
			if (/^\d{4}-\d{2}-\d{2}T/.test(s)) iso = s.slice(0, 10)
			if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
				const parts = iso.split('-')
				return `${parts[2]}/${parts[1]}/${parts[0]}`
			}
			const d = new Date(s)
			if (isNaN(d.getTime())) return s
			const day = String(d.getDate()).padStart(2, '0')
			const month = String(d.getMonth() + 1).padStart(2, '0')
			const year = d.getFullYear()
			return `${day}/${month}/${year}`
		},
		formatCurrency(value) {
			const n = Number(value || 0)
			return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
		},
		abrirFichaVehiculo(row) {
			const id = row && row.IDFLOTA
			if (!id) return
			let url = ''
			if (window.distributionapp && window.distributionapp.publicPath) {
				url = `${window.location.origin}/${window.distributionapp.publicPath}#/flota/${id}`
			} else {
				url = `${window.location.origin}#/flota/${id}`
			}
			this.openwindow(url, '_blank')
		}
	}
}
</script>

<style lang="scss" scoped>
.stage-scraping-page {
	padding: 16px;
}
h2 {
	margin: 0 0 10px;
}
.sp-card {
	background: #fff;
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 10px;
	margin-bottom: 10px;
}
.sp-title {
	font-weight: 600;
	margin-bottom: 8px;
}
.stage-center {
	min-height: 120px;
}
.sp-filters {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 140px 140px auto auto;
	gap: 8px;
	align-items: center;
}
.sp-top-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
}
.sp-kpis-inline {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
	gap: 10px;
}
.sp-kpis-card,
.sp-semaforo-card {
	margin-bottom: 0;
}
.sp-kpi-label {
	font-size: 12px;
	opacity: .8;
	display: flex;
	align-items: center;
	gap: 6px;
}
.sp-kpi-icon {
	font-size: 14px;
	line-height: 1;
}
.sp-kpi-value {
	font-size: 22px;
	font-weight: 700;
	margin-top: 4px;
}
.sp-semaforo-grid {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
}
.sp-pill {
	padding: 8px 10px;
	border-radius: 16px;
	font-size: 12px;
	font-weight: 600;
	text-align: center;
}
.verde { background: #e8f5e9; color: #2e7d32; }
.ambar { background: #fff8e1; color: #ef6c00; }
.rojo { background: #ffebee; color: #c62828; }
.sin_datos { background: #eceff1; color: #455a64; }
.sp-dimensions {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;
}
.sp-dimension h4 {
	margin: 0 0 6px;
	font-size: 13px;
	text-transform: capitalize;
}
.sp-dimension-kpis {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 8px;
}
.sp-dimension-kpi {
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 10px;
	background: #fff;
}
.sp-dimension-kpi span {
	font-size: 12px;
	color: #909399;
	display: block;
}
.sp-dimension-kpi strong {
	font-size: 18px;
}
.sp-charts {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;
	margin-top: 12px;
}
.sp-chart-card {
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 10px;
	background: #fff;
}
.sp-chart-bars {
	display: grid;
	gap: 8px;
}
.sp-bar-row {
	display: grid;
	grid-template-columns: 72px 1fr 36px;
	align-items: center;
	gap: 8px;
	font-size: 12px;
}
.sp-bar-track {
	height: 10px;
	background: #f2f4f7;
	border-radius: 999px;
	overflow: hidden;
}
.sp-bar-fill {
	height: 100%;
	border-radius: 999px;
}
.sp-bar-fill.completos {
	background: #67c23a;
}
.sp-bar-fill.faltan {
	background: #e6a23c;
}
.sp-pagination {
	margin-top: 10px;
	display: flex;
	justify-content: flex-end;
}
.sp-vehiculo-filtros {
	display: grid;
	grid-template-columns: repeat(4, 180px);
	gap: 8px;
	margin-bottom: 8px;
}
.sp-valor-total {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 10px;
	margin-bottom: 12px;
}
.sp-valor-kpi {
	border: 1px solid #ebeef5;
	border-radius: 6px;
	padding: 10px;
	background: #fff;
}
.sp-valor-kpi span {
	font-size: 12px;
	color: #909399;
	display: block;
}
.sp-valor-kpi strong {
	font-size: 18px;
}
.sp-valor-dimensiones {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 10px;
}
.sp-valor-dimension h4 {
	margin: 0 0 6px;
	font-size: 13px;
}
</style>

